import { ErrorHandler, Injectable } from '@angular/core';

@Injectable()
export class AppErrorHandlerService implements ErrorHandler {
  handleError(error: any): void {
    const message = String(error?.message || '');
    const stack = String(error?.stack || '');
    const isTrimNodeListError =
      message.includes("Cannot read properties of undefined (reading 'trim')") &&
      stack.includes('NodeList.forEach');

    if (isTrimNodeListError) {
      return;
    }

    try {
      console.error(error);
    } catch {}
  }
}
